import React, { useEffect, useState } from 'react'
import { Grid, Box, Divider, styled } from '@mui/material'
import DefaultPainel from '../../components/shared/Painel'
import AdaptativeGridContainer from '../../components/shared/AdaptativeGridContainer'
import TableHeader from '../../components/shared/tables/TableHeader'
import gerarPaginacao from '../../services/pagination'
import { Logs } from '../../services/http'
import Dater from '../../services/DateFormat'
import BaseFilter from '../../components/BaseFilter'
import BaseDatePicker from '../../components/shared/BaseDatePicker'
import BasicDatagrid from '../../components/shared/tables/BasicDatagrid'
import MobileFilterHeaderContainer from '../../components/filters/MobileFilterHeaderContainer'
import BaseTooltip from '../../components/BaseTooltip'
import HelpIcon from '@mui/icons-material/Help'
const filters = [
  {
    service: {
      folder: 'user',
      file: 'Users',
      relationship: ''
    },
    listLabel: 'name',
    label: 'Leitor',
    itemValue: 'id',
    itemText: 'name',
    id: 'user_id',
    query: {
      ativo: true
    }
  }
]

const LogsTable = styled(BasicDatagrid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('lg')]: {
    height: '71.5vh'
  },
  [theme.breakpoints.up('xl')]: {
    height: '76vh'
  },
  '& .MuiDataGrid-cell': {
    textAlign: 'start'
    // '&:nth-of-type(2)': {
    //   textAlign: 'left!important'
    // },
    // '&:nth-of-type(3)': {
    //   textAlign: 'left!important'
    // }
  }
}))

const LogsPostagem = () => {
  const [rows, setRows] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [lastPage, setLastPage] = useState(1)
  const [query, setQuery] = useState({})

  const getLogs = async (filters = {}, page) => {
    const { data } = await Logs().show({
      ...filters,
      page,
      includes: 'user.leitor.biblioteca',
      'orderBy[desc]': 'created_at'
    })
    setCurrentPage(data.current_page)
    setLastPage(data.last_page)
    const aux = data.data.map(item => ({
      ...item,
      leitor: item.user.name,
      created_at: Dater().formatar(
        item.created_at,
        'dd/mm/yyyy / hours:mins:secs'
      ),
      acoes: item.acoes,
      biblioteca: item.user.leitor.biblioteca.apelido
    }))
    setRows(aux)
  }

  const init = async () => {
    getLogs()
    setRows([])
  }

  const pagination = gerarPaginacao(
    true,
    lastPage,
    currentPage,
    (event, value) => getLogs({ ...query }, value)
  )

  useEffect(() => {
    init()
  }, [])

  const columns = [
    {
      field: 'biblioteca',
      headerName: 'Biblioteca',
      flex: 0.5
    },
    {
      field: 'leitor',
      headerName: 'Leitor',
      flex: 2
    },
    {
      field: 'acoes',
      headerName: 'Descrição',
      flex: 3
    },
    {
      field: 'created_at',
      headerName: (
        <div className="d-flex align-center">
          Data/Hora
          <BaseTooltip
            title="hora referente ao horário de Brasília"
            followCursor
          >
            <HelpIcon />
          </BaseTooltip>
        </div>
      ),
      flex: 1
    }
  ].map(item => ({ ...item, headerClassName: 'jaostyle', sortable: false }))

  const [mesAno, setMesAno] = useState(new Date())
  const formatMesAno = value => {
    let { $M } = value
    const { $y } = value
    $M = $M + 1
    setMesAno(value)
    setQuery(Object.assign(query, { created_at: prepareMes($M, $y) }))
    getLogs(query)
  }

  const prepareMes = (mes, year) => {
    let aux
    if (mes !== 12) {
      aux = `${year}-${Dater().adicionarZero(
        mes
      )}-01,${year}-${Dater().adicionarZero(mes + 1)}-01`
    } else {
      aux = `${year}-${Dater().adicionarZero(mes)}-01,${
        parseInt(year) + 1
      }-01-01`
    }
    return aux
  }

  return (
    <Box>
      <DefaultPainel sx={{ mt: '4vh' }}>
        <AdaptativeGridContainer>
          <>
            <TableHeader
              titulo="Logs Postagem"
              controls={
                <MobileFilterHeaderContainer>
                  <BaseFilter
                    color="white"
                    filter={filters}
                    onChange={value => {
                      setQuery(Object.assign(query, value))
                      getLogs(query)
                    }}
                    components={
                      <>
                        <BaseDatePicker
                          minDate={
                            parseInt(Dater().formatar(new Date(), 'yyyy')) -
                            1 +
                            '-01-01'
                          }
                          maxDate={
                            parseInt(Dater().formatar(new Date(), 'yyyy')) +
                            1 +
                            '-12-31'
                          }
                          value={mesAno}
                          onChange={formatMesAno}
                          label="Mês/Ano"
                          inputFormat="MM/YYYY"
                          mask="__/____"
                          openTo="month"
                          views={['year', 'month']}
                          onClear={() => {
                            if (query.created_at !== undefined) {
                              delete query.created_at
                              getLogs(query)
                            }
                          }}
                          clearable={true}
                        />
                      </>
                    }
                  />
                </MobileFilterHeaderContainer>
              }
            />

            <Grid item xs={12} sm={12}>
              <Divider />
              <LogsTable
                rows={rows}
                columns={columns}
                disableColumnMenu
                pagination={pagination}
              />
            </Grid>
          </>
        </AdaptativeGridContainer>
      </DefaultPainel>
    </Box>
  )
}

export default LogsPostagem
